import React, { Component } from 'react';
import styles from './VisitMuseums.module.scss';
import { IMuseumResource, MuseumCollectionDocument } from '@/interfaces/IMuseumResource';
import AddPost from '@/components/features/posts/AddPost/AddPost';
import { withTranslation, WithTranslation } from 'next-i18next';
import Heading from '@/components/core/Heading/Heading';
import PostsContainer from '@/components/features/posts/PostsContainer/PostsContainer';
import { NextRouter, withRouter } from 'next/router';
import Filter from '@/components/features/posts/Filter/Filter';
import MuseumItem from '@/components/features/visit/MuseumItem/MuseumItem';

const displayedFilters = ['past', 'current', 'upcoming'];

interface WithRouterProps {
	router: NextRouter;
}
interface IVisitMuseumsProps extends WithTranslation, WithRouterProps {
	museums: MuseumCollectionDocument;
}

class VisitMuseums extends Component<IVisitMuseumsProps> {
	getMuseumItems(data) {
		return data.map((item: IMuseumResource) => {
			return <MuseumItem key={item.id} data={item} />;
		});
	}

	render() {
		const { museums, t, router } = this.props;

		const pin = (
			<AddPost key="pin" text="host-an-exhibition" icon="/assets/icons/heart-broken.svg" to="host-an-exibition" />
		);

		const onFilterChange = (filter) => {
			if (filter) {
				router.replace({ query: { filter: filter } }, undefined, { scroll: false });
			}
		};

		return (
			<div className={styles.visitMuseums}>
				<Heading text={`${t('exhibitions')} (${museums.meta.totalCount})`}>
					<Filter
						collection={['all', ...museums.meta.filters.filter((name) => displayedFilters.includes(name))]}
						onFilterChange={onFilterChange}
					/>
				</Heading>
				<PostsContainer emptyImage="/images/empty.jpg" emptyMessage="no-exhibitions-to-show-do-you">
					{[pin, ...this.getMuseumItems(museums.data)]}
				</PostsContainer>
			</div>
		);
	}
}

export default withTranslation()(withRouter(VisitMuseums));
